export default __webpack_public_path__ + "static/media/constru-logo.b771a7ac.webp";